import isEmpty from 'lodash/isEmpty';
import { ReactNode } from 'react';
import {
  Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalProps,
} from 'reactstrap';

import LocaleService from '@services/LocaleService';
import './CustomModal.scss';

const close = LocaleService.getTranslations('general.button.close');

export interface ICustomModal {
  open: boolean
  toggle: () => void
  title?: string
  header?: ReactNode
  content?: string
  children?: ReactNode
  footer?: ReactNode
  modalProps?: ModalProps
  noHeader?: boolean
  noFooter?: boolean
  closeButtonTitle?: string
  hideCloseButton?: boolean
  type?: any
  details?: any
  setDetails?: (e: any) => void
}

function CustomModal({
  open, toggle, title, header, content, footer, children, modalProps,
  noHeader = false, noFooter = false, closeButtonTitle = close,
  hideCloseButton = false,
}: ICustomModal) {
  return (
    <Modal isOpen={open} toggle={toggle} {...modalProps}>
      {!noHeader && (
        <ModalHeader toggle={hideCloseButton ? undefined : toggle}>{isEmpty(title) ? header : <span className="s2">{title}</span>}</ModalHeader>
      )}
      <ModalBody>
        {isEmpty(content) ? children : <p className="b1 mb-0">{content}</p>}
      </ModalBody>
      {!noFooter && (
        <ModalFooter>
          {footer ?? (
            <Button color="primary" onClick={toggle} className="btn-lg btn-footer-close">
              {closeButtonTitle}
            </Button>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
}

export default CustomModal;
